import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { withCookies, Cookies } from 'react-cookie';
import { ACCESS_ENABLER_OBJ, configTempPass } from 'lib/tve';
import TVECountdown from 'components/TVE/Countdown';

class Countdown extends Component {
  static propTypes = {
    block: PropTypes.string,
    cookies: PropTypes.instanceOf(Cookies).isRequired,
  };

  static defaultProps = {
    block: '',
  };

  getExpiration = () => {
    const { expirationName } = configTempPass;
    const { cookies } = this.props;
    return parseInt(cookies.get(expirationName), 10);
  };

  render() {
    const { block } = this.props;
    return (
      <span className={`${block}__countdown`}>
        {i18next.t('Daily preview expires in')}
        &nbsp;
        <TVECountdown
          end={this.getExpiration()}
          onEndCallback={() => {
            if (
              typeof window !== 'undefined'
              && typeof window[ACCESS_ENABLER_OBJ] !== 'undefined'
              && typeof window[ACCESS_ENABLER_OBJ].logout === 'function'
            ) {
              window[ACCESS_ENABLER_OBJ].logout();
            }
          }}
        />
      </span>
    );
  }
}

export default withCookies(Countdown);
